export function getFirstFile(event: Event): File | null {
	const input = event.target as HTMLInputElement;
	return input?.files?.[0] || null;
}

export function readFileAsDataURL(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (e) => resolve(e.target?.result as string);
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}
